import _ from "underscore"
import BaseReportFormatUtils from "../reports/FormatUtils"

export default class BasePDFDefinitionColumnBuilder {

    constructor() {
        this.tableHeaderStyleNoMargin = "reportHeader"
        this.tableHeaderMargin = "reportHeaderMargin"
        this.tableHeaderStyle = ["reportHeader", "reportHeaderMargin"]
        this.tableSubHeaderStyle = ["reportSubHeader", "reportHeaderMargin"]
        this.tableSubHeaderWithMarginStyle = ["reportSubHeader", "reportTitleNormalMargin"]
        this.tableThirdLvlHeaderStyle = ["reportSubHeader", "reportHeaderMargin", "smallText"]

        this.reportTotalValue = "reportTotalValue"
        this.reportTotalTitle = ["reportHeader", "reportTotalTitle"]
        this.reportTitleBigMargin = ["reportHeader", "reportTitleBigMargin"]
        this.reportTitleNormalMargin = ["reportHeader", "reportTitleNormalMargin"]
        this.reportTitleSmallMargin = ["reportHeader", "reportTitleSmallMargin"]
        this.reportGroupingValues = ["reportFirstGroupingValue", "reportSecondGroupingValue", "reportThirdGroupingValue", "reportFourthGroupingValue"]

        this.asterisk = "asterisk"

        this.smallText = "smallText"
        this.tinyText = "tinyText"
        this.negativeValue = "negativeValue"
        this.grayText = "grayText"
    }

    init(config, rowSpanNumber) {
        this.timeFormat = config.timeFormat;
        this.formatUtil = BaseReportFormatUtils;

        this.rowSpanNumber = rowSpanNumber;

        var emptyFn = _.constant(false);
        this.valueMask = [emptyFn, emptyFn, emptyFn, emptyFn];

        return this;
    }

    pushWidth(destination, sizes) {}

    setParams(params) {
        this.params = params
    }

    makeHeader() {}

    makeTotals(data) {
        return this._makeRow(this.reportTotalValue, data, _.constant(false));
    }

    makeSubHeader() {return ''}

    makeThirdLvlHeader() {return ''}

    makeRow(lvl, data) {
        return this._makeRow(this.reportGroupingValues[lvl], data, this.valueMask[lvl]);
    }

    makeFirstRow(data) {return this.makeRow(0, data)}

    makeSecondRow(data) {return this.makeRow(1, data)}

    makeThirdRow(data) {return this.makeRow(2, data)}

    makeFourthRow(data) {return this.makeRow(3, data)}

    _makeRowDefinition(style, text) {
        return {
            style: style,
            text: text
        };
    }

    _makeHeaderDefinition(text, style) {
        if (_.isUndefined(style))
            style = this.tableHeaderStyle;

        return {
            style: style,
            text: text,
            rowSpan: this.rowSpanNumber
        };
    }

    _formatTimeValue(value) {
        return this.formatUtil.formatPureTime(value, this.timeFormat);
    }

    _formatPercentValue(value) {
        return this.formatUtil.formatPercent(value);
    }

    _formatStyle(value, style) {
        return (value < 0 ) ? [style, this.negativeValue] : style;
    }

    makeTimeCell(value, style, valueIsMasked) {
        var newStyle = valueIsMasked ? (valueIsMasked.style ? [valueIsMasked.style, style] : style) : this._formatStyle(value, style);
        var newValue = valueIsMasked ? valueIsMasked.msg : this._formatTimeValue(value);
        return {
            noWrap: true,
            style: newStyle,
            text: newValue
        }
    }

    makeTextCell(value, style) {
        return {
            noWrap: true,
            style: style,
            text: value
        }
    }

    makeSignedTimeCell(value, style, valueIsMasked) {
        var newStyle = valueIsMasked ? (valueIsMasked.style ? [valueIsMasked.style, style] : style) : this._formatStyle(value, style);
        var newValue = valueIsMasked ? valueIsMasked.msg : this._formatTimeValue(value);
        var signedValue = (value > 0) ? '+' + newValue : newValue;
        return {
            noWrap: true,
            style: newStyle,
            text: signedValue
        }
    }

    makePercentCell(value, style, valueIsMasked) {
        var newStyle = valueIsMasked ? (valueIsMasked.style ? valueIsMasked.style : style) : this._formatStyle(value, style);
        var newValue = valueIsMasked ? valueIsMasked.msg : this._formatPercentValue(value);
        return {
            noWrap: true,
            style: newStyle,
            text: newValue
        }
    }

    addAsterisk(text, asteriskChar) {
        return [
            {
                width: '*',
                text: ''
            },
            {
                width: 'auto',
                text: text,
                marginRight: 1
            },
            {
                width: 'auto',
                style: "asterisk",
                text: asteriskChar,
                marginLeft: 1,
                alignment: 'left'
            },
            {
                width: '*',
                text: ''
            }
        ];
    }
}

export class Levels extends BasePDFDefinitionColumnBuilder{
    _getTitle(groupingLevel, identity, maxLen)
    {
        return this.formatUtil.getGroupingLevelTitle(groupingLevel, identity, this.store, maxLen);
    }
}

export class Totals extends BasePDFDefinitionColumnBuilder {
    pushWidth(destination, sizes) {
        destination.push(sizes["totals"] + '%');
    }

    _getValue(data) {
        //abstract
    }

    _makeRow(style, data, valueMask) {
        return this._makeRowDefinition(style, valueMask(this, data) ? "" : this._formatTimeValue(this._getValue(data)));
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/BasePDFDefinitionColumnBuilder.js